<button type="button" [ngClass]="[buttonClass]" [disabled]="isSubmit && (loaderService.isLoading | async)">
  <ng-content></ng-content>
</button>